import { Component } from '@angular/core';
import { EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-reset-step-exito',
  templateUrl: './step-exito.component.html',
  styleUrls: ['./step-exito.component.css'],
  standalone: false
})
export class StepExitoComponent {
  @Output() reiniciar = new EventEmitter<void>();
  @Output() cerrar = new EventEmitter<void>();
}
